import Vue from "vue";
import configs from "../configs";
import md5 from "md5";
import querystring from "query-string";

const ip = `${configs.apiBase}/`;
// const ip = 'http://localhost:3001/v1/'

const login = async ({ username, senha }) => {
  const payload = {
    cpf: username,
    senha: md5(senha),
  };
  return Vue.prototype.$http.post(`${ip}new/auth/login`, payload);
};

const refreshToken = async () => {
  return Vue.prototype.$http.get(`${ip}new/auth/refresh`);
};

const getUserInfo = async () => {
  return Vue.prototype.$http.get(`${ip}usuario/search/user/info`);
};

const getUsers = async (options) => {
  return Vue.prototype.$http.get(
    `${ip}usuario/users?${querystring.stringify(options)}`,
  );
};

const getCompanies = async (options) => {
  return Vue.prototype.$http.get(
    `${ip}old/user/companies?${querystring.stringify(options)}`,
  );
};

const connectCompanies = async (payload) => {
  return Vue.prototype.$http.post(
    `${ip}usuario/connect/user/companies`,
    payload,
  );
};

const disconnectCompanies = async (payload) => {
  return Vue.prototype.$http.patch(
    `${ip}usuario/disconnect/user/companies`,
    payload,
  );
};

const recoveryUserPassword = async (payload) => {
  return Vue.prototype.$http.post(
    `${ip}new/password/recovery`,
    payload,
    {
      headers: {
        Authorization: undefined,
       'x-app-origin': window.location.origin
      }
    }
  )
};

const updateUserPassword = async (params) => {
  const payload = {
    ...params,
    security: {
      senha: md5(params.security.senha),
      confirmarSenha: md5(params.security.confirmarSenha),
    },
  };

  return Vue.prototype.$http.put(
    `${ip}new/auth/password/reset`,
    payload
  );
};

const validateToken = async (payload) => {
  return Vue.prototype.$http.post(
    `${ip}new/auth/password/validate-token`,
    payload,
    {
      headers: {
        Authorization: undefined
      }
    }
  )
};

const deactivateUser = async ({ idUsuario }) => {
  return Vue.prototype.$http.delete(`${ip}new/cadastros/usuarios/${idUsuario}/desativar`);
};

const resendConfirmEmail = async ({ idUsuario }) => {
  return Vue.prototype.$http.post(`${ip}new/cadastros/usuarios/${idUsuario}/reenviar-email`);
};

export default {
  validateToken,
  login,
  refreshToken,
  getUserInfo,
  getUsers,
  getCompanies,
  connectCompanies,
  disconnectCompanies,
  recoveryUserPassword,
  updateUserPassword,
  deactivateUser,
  resendConfirmEmail,
};